import { useState } from 'react'
import { Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faList, faXmark } from '@fortawesome/free-solid-svg-icons'
import dayjs from 'dayjs'

import ButtonCustom from '../../../../../../../../Components/ButtonCustom'
import { LineDivider } from '../../../../../../../../Components/CustomUi/LineDivider'
import { TitleH1 } from '../../../../../../../../Components/CustomUi/titleH1'
import { Select } from '../../../../../../../../Components/CustomUi/Select'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import Carregando from '../../../../../../../../Components/CustomUi/loading'
import { dados_status, statusBackground, statusBorder, statusColor, statusIcones } from '../../meta'
import './styles.css'

interface Props {
  numero_pedido: string | number
  abrirStatus: boolean
  setAbrirStatus: React.Dispatch<React.SetStateAction<boolean>>
  status_selecionada: string
  setStatus_selecionada: React.Dispatch<React.SetStateAction<string>>
  setStatus_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  dataStatusOs: any[]
  alterarStatus: Function
  loading_status: boolean
  fecharModal: Function
}

export const StatusTimeLine: React.FC<Props> = ({
  numero_pedido,
  abrirStatus,
  setAbrirStatus,
  status_selecionada,
  setStatus_selecionada,
  setStatus_selecionada_id,
  dataStatusOs,
  alterarStatus,
  loading_status,
  fecharModal,
}) => {
  const [openSelect, setOpenSelect] = useState<boolean>(false)

  return (
    <Modal
      open={abrirStatus}
      footer={null}
      closable={false}
      onCancel={() => setAbrirStatus(false)}
      className='modal-talhao'
      width={400}
      style={{ left: '300px' }}
    >
      {/* Header */}
      <div className='modal-header'>
        <ButtonCustom
          type='tertiary'
          danger
          onClick={fecharModal}
          icon={<FontAwesomeIcon icon={faXmark} />}
        >
          Fechar
        </ButtonCustom>
      </div>

      <LineDivider />

      <div className='modal-title'>
        <TitleH1>{`Pedido ${numero_pedido}`}</TitleH1>
      </div>

      <LineDivider />

      <div className='modal-content'>
        <Select
          value={status_selecionada}
          icon={faList}
          placeholder='Selecione para alterar o status'
          onChange={setStatus_selecionada}
          onChangeID={setStatus_selecionada_id}
          open={openSelect}
          trigger={setOpenSelect}
          items={dados_status}
          descricaoItem={'nome'}
          idItem={'cod'}
        />
        <ButtonCustom
          onClick={alterarStatus}
          icon={<FontAwesomeIcon icon={faFloppyDisk} />}
          style={{ marginTop: '5px' }}
        />
      </div>

      <div className='container_modal'>
        <Render condition={loading_status}>
          <Carregando animation justifyContent='center' size='default' legenda='Carregando...' height={200} />
        </Render>
        <Render condition={loading_status === false}>
          {dataStatusOs?.map((item) => {
            return (
              <div key={item?.cod} style={{ display: 'flex', gap: 10, paddingLeft: '10px', paddingRight: '10px' }}>
                <div className='container_status'>
                  <div className='icone_line'>
                    <FontAwesomeIcon
                      fontSize={12}
                      icon={statusIcones[item?.status]}
                      style={{
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '10px',
                        borderRadius: '50%',
                        backgroundColor: statusBackground[item?.status],
                        border: `1px solid ${statusBorder[item?.status]}`,
                        color: statusColor[item?.status],
                      }}
                    />
                    <div className='line' />
                  </div>
                </div>
                <div className='nome_status'>
                  <h3 style={{ color: statusColor[item?.status] }}>{item?.status_nome}</h3>
                  <span>{item?.usuario_nome}</span>
                  <p>{dayjs(item?.data_hora).format('DD/MM/YYYY')}</p>
                </div>
              </div>
            )
          })}
        </Render>
      </div>
    </Modal>
  )
}
